/**
 * Manage Routes (Authenticated)
 */
export default [
    {
        path: '/manage',
        name: 'manage',
        component: () => import('../../pages/manage/IndexPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Manage Account',
        },
    },
    {
        // PROXY_FAMILY + PARENT_PROXY — 통합 페이지 (탭 2개: 자녀 가입 / 동의 대기)
        path: '/account/proxy-family',
        name: 'proxyFamily',
        component: () => import('../../pages/account/ProxyFamilyPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Proxy Family',
        },
    },
    {
        // 구 경로 호환 — /account/pending-proxy-consents 는 통합 페이지의 pending 탭으로
        path: '/account/pending-proxy-consents',
        redirect: { name: 'proxyFamily', query: { tab: 'pending' } },
    },
    {
        // 구 경로 호환 — /account/children/register 는 통합 페이지의 register 탭으로
        path: '/account/children/register',
        redirect: { name: 'proxyFamily', query: { tab: 'register' } },
    },
    {
        path: '/manage/changepassword',
        name: 'changePassword',
        component: () => import('../../pages/manage/ChangePasswordPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Change Password',
        },
    },
    {
        path: '/manage/externallogins',
        name: 'externalLogins',
        component: () => import('../../pages/manage/ExternalLoginsPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'External Logins',
        },
    },
    {
        path: '/manage/enableauthenticator',
        name: 'enableAuthenticator',
        component: () => import('../../pages/manage/EnableAuthenticatorPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Enable Authenticator',
        },
    },
    {
        path: '/manage/twofactorauthentication',
        name: 'twoFactorAuthentication',
        component: () => import('../../pages/manage/TwoFactorAuthPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Two-Factor Authentication',
        },
    },
    {
        path: '/manage/setpassword',
        name: 'setPassword',
        component: () => import('../../pages/manage/SetPasswordPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Set Password',
        },
    },
    {
        path: '/manage/leave',
        name: 'leave',
        component: () => import('../../pages/manage/LeavePage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Leave',
        },
    },
    {
        // /manage 안 교회정보 섹션으로 스크롤되도록 hash 사용. 기존 북마크 호환.
        path: '/manage/church-info',
        name: 'churchInfo',
        redirect: (to) => ({
            name: 'manage',
            query: to.query,
            hash: '#church-info-section',
        }),
    },
    {
        path: '/manage/transfer',
        name: 'transfer',
        component: () => import('../../pages/manage/TransferPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Church Transfer',
        },
    },
    {
        path: '/manage/linkloginfailure',
        name: 'linkLoginFailure',
        component: () => import('../../pages/manage/LinkLoginFailurePage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Link Login Failure',
        },
    },
    {
        // 내정보 통합 탭으로 이관 — /manage?tab=status. 기존 경로/북마크 호환 리다이렉트.
        path: '/manage/change-status',
        name: 'profileChangeStatus',
        redirect: { name: 'manage', query: { tab: 'status' } },
    },
];
